import React, { useState } from 'react';
import { Box, Menu, Typography } from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import clsx from 'clsx';
import { DropdownMenu } from '@rcg/ui-react';
import Button from '../../../UiComponents/Button';
import useStyles from './index.style';

export default function CounterMenu({
  lowLimit = 2,
  defaultValue = 2,
  highLimit = 4,
  singleLabel = 'Passenger',
  multipleLabel = 'Passengers',
  cancelLabel = 'Cancel',
  doneLabel = 'Done',
  showButtons = true,
  handleCount = () => {},
  className,
  menuData = [],
  selectedOption = () => {},
  selectedFlightType = null,
  ...others
}) {
  const [counter, setCounter] = useState(defaultValue);
  const [anchorEl, setAnchorEl] = useState(null);
  const [initialCount, setInitialCount] = useState('');
  const open = Boolean(anchorEl);
  const classes = useStyles();

  const handleMenu = (event) => {
    setInitialCount(counter);
    setAnchorEl(event.currentTarget);
  };
  const handleDone = () => {
    setAnchorEl(null);
    handleCount(counter);
  };
  const handleCancel = () => {
    setCounter(initialCount);
    handleCount(initialCount);
    setAnchorEl(null);
  };

  return (
    <Box className={clsx(classes.counterMenu, className)} {...others}>
      <DropdownMenu
        key={menuData[0].id}
        id={menuData[0].id}
        onSelectedOption={selectedOption}
        disabled={menuData[0].disabled}
        menuItems={menuData[0].items}
        setSelectedOption={selectedFlightType}
      />
      <Button
        disableRipple
        id="counter-menu-button"
        aria-controls="simple-menu"
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        className={classes.dropLabel}
        onClick={handleMenu}>
        {counter}
        {counter === 1 ? ` ${singleLabel}` : ` ${multipleLabel}`} <KeyboardArrowDownIcon />
      </Button>
      <Menu
        id="simple-menu"
        data-testid="counter-menu"
        aria-labelledby="counter-menu-button"
        classes={{ paper: classes.paper }}
        anchorEl={anchorEl}
        keepMounted
        anchorOrigin={{
          vertical: 'top',
          horizontal: 180,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={open}
        onClose={handleCancel}>
        <Box className={classes.menu}>
          <Box className={classes.wrapperCounter}>
            <Typography variant="body1">{multipleLabel}</Typography>
            <Box className={classes.counter}>
              <Button
                disabled={counter === lowLimit}
                classes={{ disabled: classes.disabledButton }}
                onClick={() => setCounter(counter - 1)}>
                <RemoveIcon />
              </Button>
              <Typography component="span">{counter}</Typography>
              <Button
                disabled={counter === highLimit}
                classes={{ disabled: classes.disabledButton }}
                onClick={() => setCounter(counter + 1)}>
                <AddIcon />
              </Button>
            </Box>
          </Box>
          {showButtons && (
            <Box className={classes.footerMenu}>
              <Button variant="text" onClick={handleCancel}>
                {cancelLabel}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.primaryButton}
                onClick={handleDone}>
                {doneLabel}
              </Button>
            </Box>
          )}
        </Box>
      </Menu>
    </Box>
  );
}
